// extracted by mini-css-extract-plugin
export default {"title":"LeadershipTab_title__tpZs7","card":"LeadershipTab_card__R67ZO","select":"LeadershipTab_select__ocN0-"};